import React, { createContext, useReducer, useContext } from 'react';

const PluginShopStateContext = createContext();
const PluginShopDispatchContext = createContext();

const getInitPluginShopState = () => ({
  amount: 0,
  pluginTarget: '',
  pluginName: '',
});

const pluginShopReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'purchasePage':
      return { ...state, ...payload };
    case 'cancel':
      return { ...state, ...getInitPluginShopState() };
    default:
      throw new Error('Invalid action type');
  }
};

const PluginShopProvider = ({ children }) => {
  const [state, dispatch] = useReducer(pluginShopReducer, getInitPluginShopState());

  return (
    <PluginShopStateContext.Provider value={state}>
      <PluginShopDispatchContext.Provider value={dispatch}>{children}</PluginShopDispatchContext.Provider>
    </PluginShopStateContext.Provider>
  );
};

const usePluginShopState = () => {
  const context = useContext(PluginShopStateContext);

  if (context === undefined) {
    throw new Error('usePluginShopState must be used within a PluginShopProvider');
  }
  return context;
};

const usePluginShopDispatch = () => {
  const context = useContext(PluginShopDispatchContext);

  if (context === undefined) {
    throw new Error('usePluginShopDispatch must be used within a PluginShopProvider');
  }
  return context;
};

export { PluginShopProvider, usePluginShopState, usePluginShopDispatch };
